import { render, staticRenderFns } from "./CriaToken.vue?vue&type=template&id=ec15cd8e"
import script from "./CriaToken.vue?vue&type=script&lang=js"
export * from "./CriaToken.vue?vue&type=script&lang=js"
import style0 from "./CriaToken.vue?vue&type=style&index=0&id=ec15cd8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports